import './Languages.css'
import {Card} from "../../components/card/Card";

const JavaScript = require('./images/JavaScript.png')
const CPP = require('./images/CPP.png')
const Python = require('./images/Python.png')

function Languages() {
    return (
        <section className='languages'>
            <Card
                name='JavaScript'
                description='Multitasking.'
                img={JavaScript}
                type='light'
                buttonText='Skills'
            />

            <Card
                    name='C & C++'
                    description='Speed.'
                    img={CPP}
                    type='dark'
                    buttonText='Skills'
            />

            <Card
                    name='Python'
                    description='Reliability.'
                    img={Python}
                    type='light'
                    buttonText='Skills'
            />

        </section>
    )
}

export default Languages